<template>
  <!-- 플랫폼, 공정도 설명 페이지 -->
  <!-- wrap : S -->
  <div>
      <div class="sub_top">
          <div class="sub_tit">
              <div class="sub_tit_inner">
                  <h2>공정도</h2>
              </div>
          </div>
      </div>

      <!-- container : S -->
      <div class="ptc_container">
          <div class="info_section">
              <div class="info_txt">
                  <span class="lbtx">공정도란?</span>
                  <p class="txt_typ_lg"><span class="txt_ib">소재가 만들어지는</span><span class="txt_ib">과정을 표현한 순서도</span></p>
                  <hr class="hr_line" />
                  <p class="txt_typ_3">공정도는 재료(Material), 공정(Process), 측정(Measurement) 및 분석(Analysis)의 단위로 소재가 만들어지는 과정을 표현합니다.</p>
                  <p class="txt_typ_3">측정 및 분석은 소자/소재가 만들어지는 이력의 메타정보를 기반으로 하기때문에, 공정도는 측정분석 프로토콜을 이해하는 데 있어서 꼭 필요한 안내판입니다</p>
                  <a href="#" @click="handleClick" class="info_txt_btn">공정도 만들어 보기</a>
              </div>
              <div class="info_graphic">
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/processchart_01.png" alt="" />
                  </div>
              </div>
          </div>

          <div class="info_section">
              <div class="info_txt">
                  <span class="lbtx">CheckPoint 01</span>
                  <p class="txt_typ_md">복잡한 소재 제작 과정을 직관적으로 알 수 있습니다.</p>
              </div>
              <div class="info_graphic">
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/processchart_02.png" alt="" />
                  </div>
              </div>
          </div>

          <div class="info_section">
              <div class="info_txt">
                  <span class="lbtx">CheckPoint 02</span>
                  <p class="txt_typ_md">나만의 연구 과정을 쉽게 정리하고 설명할 수 있습니다.</p>
              </div>
              <div class="info_graphic">
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/processchart_03.png" alt="" />
                  </div>
              </div>
          </div>

          <div class="info_section">
              <div class="info_txt">
                  <span class="lbtx">CheckPoint 03</span>
                  <p class="txt_typ_md">전문가들이 실험 방법을 검증하고 공개해줍니다.</p>
              </div>
              <div class="info_graphic">
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/processchart_03.png" alt="" />
                  </div>
              </div>
          </div>

          <div class="info_section">
              <div class="info_txt">
                  <span class="lbtx">CheckPoint 04</span>
                  <p class="txt_typ_md">전문가들이 검증한 소재 제작 정보를 검색을 통해 손쉽게 획득할 수 있습니다.</p>
              </div>
              <div class="info_graphic">
                  <div class="info_graphic_img">
                      <img src="@/style/new/images/info/processchart_03.png" alt="" />
                  </div>
                  <p class="desc_txt typ1">프로토콜 플랫폼은 복잡한 소재 제작과정을 쉽고 편리하게 제작할 수 있는 공정도 편집기능을 제공하여, 나만의 연구 과정을 쉽게 정리 할 수 있습니다.</p>
                  <p class="desc_txt typ2">또한 전문가들이 <span class="colr">검증하고 공개한 다양한 공정들을 검색하고 활용</span>할 수 있어, 더욱 효율적인 연구를 할 수 있도록 도와줍니다.</p>
              </div>
          </div>
      </div>
      <!-- container : E -->

      <div class="btm_banner">
          <div class="btm_banner_inner">
              <p>효율적인 연구를 하기위한 공정도를 만들어보세요.</p>
              <a href="#" @click="handleClick" class="linkbtn">공정도 만들어 보기</a>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  methods : {
    handleClick() {
      if( this.user && !this.user.admin && !this.user.assistant && !this.user.committee && !this.user.super && !this.user.generalManager ){
        window.alert( "일반 유저는 에디터 접근이 불가합니다." );
      }else if (this.user) window.open(this.$router.resolve("/process/gate").href);
      else this.$router.push("/account/login");
    },
  }
};
</script>

<style lang="scss" scoped></style>
